import {
  APIResponse,
  get as originalGet,
  post as originalPost,
} from '@shopee-user-common/fetch-utils';
import { BusinessTargetConfig } from '@shopee-user/global';
import { config } from '@shopee-user/platform';
import { getOrCreateCsrfTokenCookie } from '@tob/shared/security/csrf';

const { BUSINESS_TARGET, ENV, LOCALE, DEV, IS_LOCAL } = config;

const { appType, getApiDomain } = BusinessTargetConfig[BUSINESS_TARGET];

const ABSOLUTE_URL_REGEX = /^http(s)?:\/\//i;

// BE requires this custom header to differentiate between ToB app_type
export const CUSTOM_HEADERS = {
  'x-app-type': appType.toString(),
  'X-CSRFToken': getOrCreateCsrfTokenCookie({ cookiePrefix: '' }),
};

export const API_URL: string = DEV || IS_LOCAL ? '' : getApiDomain(ENV, LOCALE);

type RequestInitAdditional = {
  relativeUrl?: boolean;
};

/**
 * @deprecated use fetch-utils-v2
 */
export async function get<T>(
  url: string,
  options: RequestInit & RequestInitAdditional = {}
): Promise<APIResponse<T>> {
  const domain =
    options.relativeUrl || ABSOLUTE_URL_REGEX.test(url) ? '' : API_URL;
  return originalGet(`${domain}${url}`, {
    ...options,
    headers: {
      ...options.headers,
      ...CUSTOM_HEADERS,
    },
  });
}

/**
 * @deprecated use fetch-utils-v2
 */
export async function post<T>(
  url: string,
  body: unknown,
  options: RequestInit & RequestInitAdditional = {}
): Promise<APIResponse<T>> {
  const domain =
    options.relativeUrl || ABSOLUTE_URL_REGEX.test(url) ? '' : API_URL;
  return originalPost(`${domain}${url}`, body, {
    ...options,
    headers: {
      ...options.headers,
      ...CUSTOM_HEADERS,
    },
  });
}
